import { Card, CardContent, IconButton, InputBase, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import './students.scss'
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import AddIcCallRoundedIcon from '@mui/icons-material/AddIcCallRounded';
import profilePic from "../../../assets/user.jpg"
import { useAppSelector } from "../../../store/hooks/hooks";

const fetchProfilePics = (length:string) => {
    return fetch(`https://randomuser.me/api/?results=${length}`).then(res => res.json()).then(result => {
        return result
    })
}


const StudentContainer = () => {
    const [searchText, SetSearchText] = useState("")
    const [images,setImages] = useState([])
    const placementLists = useAppSelector((state: any) => state.admin.placements)
    const searchStudents = (inputText: string) => {
        return placementLists.filter((elm: any) => {
            return ("" + elm.user.first_name).includes(inputText) || ("" + elm.user.last_name).includes(inputText)
        })

    }
    useEffect(() => {
        fetchProfilePics(placementLists.length).then(res => {
            setImages(res.results.map((elm:any) => {
                return elm.picture.large
            }))
        })
    },[placementLists])
    console.log(searchStudents(searchText))


    return (
        <div className="w-100">
            <div className="flex justify-content-between pt-4 px-4 w-100">
                <h1 className="title_Student">Students</h1>
                <Paper
                    component="form"
                    className="inputBox"
                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                >
                    <InputBase
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Search Students"
                        inputProps={{ 'aria-label': 'search students' }}
                        value={searchText}
                        onChange={(e) => {
                            SetSearchText(e.target.value)
                        }}
                    />
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon />
                    </IconButton>
                </Paper>
            </div>
            <div className="grid-Container p-4">
                {
                    searchStudents(searchText)[0] && <>
                        <Card className="grid-item1 studentCard">
                            <CardContent className="p-0 w-100 h-100">
                                <div className="flex flex-column h-100 justify-content-between w-100">
                                    <div className="flex justify-content-end w-100">
                                        <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[0].user.email}`}>
                                            <EmailRoundedIcon fontSize="inherit" />
                                        </IconButton>
                                    </div>
                                    <div className="flex justify-content-center">
                                        <img src={images[0] ? images[0]:profilePic} alt="profilePicture" className="profilePic"></img>
                                    </div>
                                    <div>
                                        <p className="font-weight-700 m-0">{searchStudents(searchText)[0].user.first_name} {searchStudents(searchText)[0].user.last_name}</p>
                                        <p className="body-p gray-color subTitle">{searchStudents(searchText)[0].placement.JobRoles}</p>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </>
                }
                {
                    searchStudents(searchText)[1] &&
                    <Card className="grid-item2 studentCard align-items-center">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[1].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                   
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[1] ? images[1]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[1].user.first_name} {searchStudents(searchText)[1].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[1].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[2] && <Card className="grid-item3 studentCard align-items-center">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small">
                                        <EmailRoundedIcon fontSize="inherit" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[2].user.email}`}/>
                                    </IconButton>
                                    
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[2] ? images[2]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[2].user.first_name} {searchStudents(searchText)[2].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[2].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[3] && <Card className="grid-item4 studentCard">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[3].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                    
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[3] ? images[3]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[3].user.first_name} {searchStudents(searchText)[3].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[3].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[4] && <Card className="grid-item5 studentCard align-items-center">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[4].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                    
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[4] ? images[4]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[4].user.first_name} {searchStudents(searchText)[4].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[4].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[5] && <Card className="grid-item6 studentCard">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[5].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                   
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[5] ? images[5]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[5].user.first_name} {searchStudents(searchText)[5].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[5].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[6] && <Card className="grid-item7 studentCard">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[6].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                    
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[6] ? images[6]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[6].user.first_name} {searchStudents(searchText)[6].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[6].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[7] && <Card className="grid-item8 studentCard">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[7].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                    
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[7] ? images[7]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[7].user.first_name} {searchStudents(searchText)[7].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[7].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[8] && <Card className="grid-item9 studentCard">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[8].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                   
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[8] ? images[8]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[8].user.first_name} {searchStudents(searchText)[8].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[8].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    searchStudents(searchText)[9] && <Card className="grid-item10 studentCard">
                        <CardContent className="p-0 w-100 h-100">
                            <div className="flex flex-column h-100 justify-content-between w-100">
                                <div className="flex justify-content-end w-100">
                                    <IconButton aria-label="mail" size="small" onClick={() => window.location.href  = `mailto:${searchStudents(searchText)[9].user.email}`}>
                                        <EmailRoundedIcon fontSize="inherit" />
                                    </IconButton>
                                   
                                </div>
                                <div className="flex justify-content-center">
                                    <img src={images[9] ? images[9]:profilePic} alt="profilePicture" className="profilePic"></img>
                                </div>
                                <div>
                                    <p className="font-weight-700 m-0">{searchStudents(searchText)[9].user.first_name} {searchStudents(searchText)[9].user.last_name}</p>
                                    <p className="body-p gray-color subTitle">{searchStudents(searchText)[9].placement.JobRoles}</p>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                }
            </div>
        </div>
    )

}
export default StudentContainer